import projection from '../generated/pwc5m2f1.json';
import { AcceptanceManifest } from '../types';

export const pwc5m2f1AcceptanceManifest = projection as AcceptanceManifest;
